import { render, staticRenderFns } from "./PageForgotPassword.vue?vue&type=template&id=3437b26f&"
import script from "./PageForgotPassword.vue?vue&type=script&lang=js&"
export * from "./PageForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports